import React from "react";
import {
  Trash2,
  Printer,
  Sparkles,
  Reply,
  Archive,
  Forward,
  ReplyAll,
  ClipboardCheck,
  Minimize2,
  Maximize2,
  ShieldCheck,
  Download,
  FileCode,
  FileText,
} from "lucide-react";

// Barra inferiore: ELIMINA | STAMPA | SCEGLI RISPONDI | AI (l'allegato si aggiunge solo in Scrivi/Rispondi/Inoltra)
// "Scegli rispondi" e "AI" aprono tendine verso l'alto come nel mockup
export default function BottomToolbar({
  ns,
  openMenu,
  setOpenMenu,
  onTrash,
  onPrint,
  onSave,
  onTranslate,
  onReplyAction,
  onAIAction,
}) {
  const replyId = ns + "-reply";
  const aiId = ns + "-ai";
  const saveId = ns + "-save";
  const aperto = openMenu === replyId || openMenu === aiId || openMenu === saveId;
  const toggle = (id) => setOpenMenu(openMenu === id ? null : id);

  const replyItems = [
    { icon: Archive, label: "Archivia", action: "archivia" },
    { icon: Forward, label: "Inoltra", action: "inoltra" },
    { icon: ReplyAll, label: "Rispondi a tutti", action: "rispondi_tutti" },
    { icon: Reply, label: "Rispondi", action: "rispondi" },
  ];

  const aiItems = [
    { icon: ClipboardCheck, label: "Correggi", action: "correggi" },
    { icon: Minimize2, label: "Riduci", action: "riduci" },
    { icon: Maximize2, label: "Espandi", action: "espandi" },
    { icon: ShieldCheck, label: "Rettifica", action: "rettifica" },
  ];

  return (
    <div className={`bottom-toolbar ${aperto ? "menu-aperto" : ""} ${openMenu === replyId ? "menu-reply" : ""} ${openMenu === aiId ? "menu-ai" : ""} ${openMenu === saveId ? "menu-save" : ""}`} data-testid="bottom-toolbar">
      {aperto && (
        // sfondo oscurato DENTRO la barra: stesso contesto di impilamento dei tasti → tasti e tendina sempre in primo piano
        <div className="dd-backdrop dentro-barra" onClick={() => setOpenMenu(null)} data-testid={ns + "-dd-backdrop"} />
      )}
      <button className="icon-btn con-tip tip-su" onClick={onTrash} aria-label="Elimina" data-tip="Elimina" data-testid="toolbar-trash">
        <Trash2 size={21} strokeWidth={2.3} />
      </button>
      <button className="icon-btn con-tip tip-su" onClick={onPrint} aria-label="Stampa" data-tip="Stampa" data-testid="toolbar-print">
        <Printer size={21} strokeWidth={2.3} />
      </button>

      {/* Salva -> tendina verso l'alto: HTML / PDF */}
      {onSave && (
        <div className="anchor-wrap">
          <button className="icon-btn save-btn con-tip tip-su" data-tip="Salva" onClick={() => toggle(saveId)} aria-label="Salva" data-testid="toolbar-save">
            <Download size={21} strokeWidth={2.3} />
          </button>
          {openMenu === saveId && (
            <div className="dropdown up dashed dropdown-salva" data-title="Salva" data-testid="dropdown-save">
              <button className="icon-plain dd-icon dd-icon-testo" onClick={() => { onSave("html"); setOpenMenu(null); }} data-testid="save-html">
                <FileCode size={22} strokeWidth={2.3} />
                <span>Salva come HTML</span>
              </button>
              <button className="icon-plain dd-icon dd-icon-testo" onClick={() => { onSave("pdf"); setOpenMenu(null); }} data-testid="save-pdf">
                <FileText size={22} strokeWidth={2.3} />
                <span>Salva come PDF</span>
              </button>
            </div>
          )}
        </div>
      )}

      {/* Scegli rispondi -> tendina verso l'alto */}
      <div className="anchor-wrap">
        <button
          className="icon-btn reply-orange con-tip tip-su"
          data-tip="Rispondi / Inoltra"
          onClick={() => toggle(replyId)}
          aria-label="Scegli rispondi"
          data-testid="toolbar-reply"
        >
          <Reply size={26} strokeWidth={2.5} />
        </button>
        {openMenu === replyId && (
          <div className="dropdown up dashed" data-title="Rispondi" data-testid="dropdown-reply">
            {replyItems.map((it) => (
              <button
                key={it.action}
                className="icon-plain dd-icon con-tip tip-sx"
                data-tip={it.label}
                aria-label={it.label}
                onClick={() => {
                  onReplyAction(it.action);
                  setOpenMenu(null);
                }}
                data-testid={`reply-${it.action}`}
              >
                <it.icon size={24} strokeWidth={2.3} />
              </button>
            ))}
          </div>
        )}
      </div>

      {/* AI -> tendina verso l'alto: correggi/riduci/espandi/rettifica */}
      <div className="anchor-wrap">
        <button
          className="icon-btn ai-btn con-tip tip-su"
          data-tip="Assistente AI"
          onClick={() => toggle(aiId)}
          aria-label="Assistente AI"
          data-testid="toolbar-ai"
        >
          <Sparkles size={26} strokeWidth={2.4} fill="currentColor" />
        </button>
        {openMenu === aiId && (
          <div className="dropdown up dashed align-right" data-title="AI" data-testid="dropdown-ai">
            {aiItems.map((it) => (
              <button
                key={it.action}
                className="icon-plain dd-icon con-tip tip-sx"
                data-tip={it.label}
                aria-label={it.label}
                onClick={() => {
                  onAIAction(it.action);
                  setOpenMenu(null);
                }}
                data-testid={`ai-${it.action}`}
              >
                <it.icon size={24} strokeWidth={2.3} />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
